/* Smooth scrolling for the theme — Lenis (bundled locally as lenis.min.js).
   Skips: reduced-motion, and the splash / enter-page overlay. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof Lenis === 'undefined') return;
  /* the enter page is a fixed full-screen overlay — no page scroll to smooth */
  if (document.querySelector('.wrapper.enter--v2')) return;

  var PREVENT = [
    'cart-drawer', '.drawer__inner', '.cart-drawer', '.menu-drawer',
    '.cart-notification', '.modal__content', '.pm-modal__content',
    '.size-guide-modal__content', '[role="dialog"]', '.js-lenis-prevent'
  ].join(',');

  function markPrevent(scope) {
    (scope || document).querySelectorAll(PREVENT).forEach(function (el) {
      el.setAttribute('data-lenis-prevent', '');
    });
  }

  var lenis = new Lenis({
    duration: 1.05,
    easing: function (t) { return 1 - Math.pow(1 - t, 3); },
    smoothWheel: true,
    wheelMultiplier: 0.92,
    lerp: 0.12
  });
  window.editionLenis = lenis;

  function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  markPrevent();

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var hash = href.indexOf('#') > -1 ? href.slice(href.indexOf('#') + 1) : '';
    if (!hash) return;
    if (link.pathname && link.pathname !== window.location.pathname) return;
    var target = document.getElementById(hash);
    if (!target) return;
    e.preventDefault();
    lenis.scrollTo(target, { offset: -90, duration: 1.1 });
  });

  document.addEventListener('shopify:section:load', function (e) { markPrevent(e.target); lenis.resize(); });
  document.addEventListener('shopify:section:select', function () { lenis.stop(); });
  document.addEventListener('shopify:section:deselect', function () { lenis.start(); });

  /* pause momentum only while the page is scroll-locked for a drawer/modal */
  var bodyMo = new MutationObserver(function () {
    var locked = /(^|\s)(overflow-hidden|scroll-lock|js-drawer-open|menu-open)/.test(document.body.className);
    if (locked && !lenis.isStopped) lenis.stop();
    else if (!locked && lenis.isStopped) lenis.start();
  });
  bodyMo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
